import { toResponseError, type ResponseSuccess, type RoleMemberRemoveInput } from '@terros/common'
import { withoutRole } from '../user/listRoles'
import { useUserCache } from '../user'
import { useTantalimMutation } from '../mutation'
import { mutationRemove, type RemoveHookResponse } from '../hooks'
import { useRoleCache } from './cache'

export function useRemoveRoleMember(): RemoveHookResponse<RoleMemberRemoveInput> {
  const cache = useRoleCache()
  const mutation = useTantalimMutation<RoleMemberRemoveInput, ResponseSuccess>({ url: '/role/member/remove' })

  const profileCache = useUserCache()

  async function remove(props: RoleMemberRemoveInput): Promise<void> {
    try {
      await mutation.mutateAsync(props)
      cache.clearItem(props.roleId)
      profileCache.clearProfile(props.userId)
      profileCache.syncListedRoles(props.userId, (roles) => withoutRole(roles, props.roleId))
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationRemove(mutation, remove)
}
